import styled from 'styled-components'

import {
  Dropzone,
  DropzoneFileNames,
  DropzonePreviews,
  Button as LMFButton,
  TypeStyle,
} from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../../app/_components/navigation/NextLink'
import { Label as SharedLabel } from '../../../../Modal/primitives/shared-form-styles'
import * as Name from '../../TextEmbroideryForm/FormBody/Name'

export const LearnMoreLink = styled(NextLink)`
  text-decoration: underline;
`

export const WarningLabel = styled(TypeStyle.BodyNano)`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.color.deprecated.stoneLighter};
  border-radius: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(4)};
  margin-bottom: ${props => props.theme.spacing(6)};
  line-height: 20px;
`

export const HeadlineMicro = styled(TypeStyle.HeadlineMicro)`
  margin: ${props => props.theme.spacing(6)} 0;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  letter-spacing: 0.65px;
  line-height: 22px;
  font-size: 13px;
`

export const Button = styled(LMFButton)`
  width: 100%;
  line-height: 18px;
  padding: ${props => props.theme.spacing(4)} 0;
  margin-bottom: ${props => props.theme.spacing(6)};
`
export const Label = styled(SharedLabel)`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.theme.spacing(6)} 0 ${props => props.theme.spacing(2)} 0;
  align-items: center;
`

export const MicroCaps = styled(TypeStyle.HeadlineMicro)`
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  line-height: ${o => o.theme.typography.font.lineHeight.loose};
`

export const StyledNameWrapper = styled(Name.Wrapper)`
  h3 {
    letter-spacing: 1.6px;
    line-height: 16px;
  }
`

export const StyledHr = styled.hr`
  margin: ${o => o.theme.spacing(6)} 0;
  border: none;
  border-top: 1px solid ${o => o.theme.color.button.disabled.border.on.background};
`
export const Text = styled(TypeStyle.BodySmall)`
  font-weight: 100;
  font-size: ${o => o.theme.spacing(3.5)};
`

export const DropzoneContainer = styled(Dropzone)`
  margin-top: ${o => o.theme.spacing(2)};
  width: 100%;
`

export const DropzoneImagePreview = styled(DropzonePreviews)`
  width: 100%;
`

export const FileNames = styled(DropzoneFileNames)`
  text-align: right;
`
